import { Routes } from '@angular/router';

import { PRIVATE_ROUTES } from './modules/private/private.routes';
import { PUBLIC_ROUTES } from './modules/public/public.routes';

export const APP_ROUTES: Routes = [
  // Redirect inicial PRIMERO
  {
    path: '',
    redirectTo: '/landing',
    pathMatch: 'full'
  },
  // Rutas públicas
  ...PUBLIC_ROUTES,
  // Rutas privadas
  ...PRIVATE_ROUTES,
  // Wildcard SIEMPRE AL FINAL
  {
    path: '**',
    redirectTo: 'not-found'
  }
];
